module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "driver-details-container"
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Driver Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "warning",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.openDriverModal
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v("New Driver\n            ")], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "disabled": _vm.isImporting,
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.importExcel
    }
  }, [_c('md-icon', [_vm._v("file_upload")]), _vm._v(_vm._s(_vm.importButtonText) + "\n              "), (_vm.isImporting) ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Importing..."
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.isExporting,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.exportDriverReport
    }
  }, [_c('md-icon', [_vm._v("file_download")]), _vm._v(_vm._s(_vm.exportButtonText) + "\n              "), (_vm.isExporting) ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Exporting..."
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-3"
  }, [_c('h5', {
    staticClass: "text-muted mb-0"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "options": _vm.pageOptions,
      "size": "sm"
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("per page")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-input-group', [_c('b-input-group-prepend', [_c('b-input-group-text', [_c('md-icon', [_vm._v("search")])], 1)], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Search drivers...",
      "disabled": _vm.isLoading
    },
    on: {
      "input": _vm.handleSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), (_vm.searchQuery) ? _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.driverList,
      "fields": _vm.tableFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "busy": _vm.isLoading,
      "empty-text": "No drivers found",
      "empty-filtered-text": "No drivers match your search criteria"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "driverName",
      fn: function(row) {
        return [_c('b-button', {
          staticClass: "p-0 text-primary",
          attrs: {
            "variant": "link",
            "size": "sm",
            "disabled": _vm.isLoading
          },
          on: {
            "click": function($event) {
              _vm.viewDriverDetails(row.item.driverId)
            }
          }
        }, [_vm._v("\n              " + _vm._s(row.value) + "\n            ")])]
      }
    }, {
      key: "driverContact",
      fn: function(row) {
        return [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(row.value || 'N/A'))])]
      }
    }, {
      key: "driverVehicleNumber",
      fn: function(row) {
        return [_c('span', {
          staticClass: "font-weight-bold text-info"
        }, [_vm._v(_vm._s(row.value || 'N/A'))])]
      }
    }, {
      key: "driverDateOfJoining",
      fn: function(row) {
        return [_c('span', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(_vm.formatDate(row.value)))])]
      }
    }, {
      key: "driverDateOfLeaving",
      fn: function(row) {
        return [_c('span', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(_vm.formatDate(row.value)))])]
      }
    }, {
      key: "driverDateOfBirth",
      fn: function(row) {
        return [_c('span', {
          staticClass: "text-info"
        }, [_vm._v(_vm._s(_vm.formatDate(row.value)))])]
      }
    }, {
      key: "license_no",
      fn: function(row) {
        return [_c('span', {
          staticClass: "font-monospace text-primary"
        }, [_vm._v(_vm._s(row.value || 'N/A'))])]
      }
    }, {
      key: "driverUANNumber",
      fn: function(row) {
        return [_c('span', {
          staticClass: "font-monospace text-secondary"
        }, [_vm._v(_vm._s(row.value || 'N/A'))])]
      }
    }, {
      key: "driverWorkingYear",
      fn: function(row) {
        return [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(_vm._s(row.value || 'N/A'))])]
      }
    }, {
      key: "driverEsic",
      fn: function(row) {
        return [_c('span', {
          staticClass: "font-monospace"
        }, [_vm._v(_vm._s(row.value || 'N/A'))])]
      }
    }, {
      key: "accountNo",
      fn: function(row) {
        return [_c('span', {
          staticClass: "font-monospace"
        }, [_vm._v(_vm._s(row.value || 'N/A'))])]
      }
    }, {
      key: "driverType",
      fn: function(row) {
        return [_c('b-badge', {
          attrs: {
            "variant": row.value === '1' ? 'success' : 'warning'
          }
        }, [_vm._v("\n              " + _vm._s(row.value === '1' ? 'Permanent' : (row.value === '2' ? 'Temporary' : 'N/A')) + "\n            ")])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-info",
            "disabled": _vm.isLoading,
            "title": "View Driver Profile"
          },
          on: {
            "click": function($event) {
              _vm.viewDriverProfile(row.item.driverId)
            }
          }
        }, [_c('md-icon', [_vm._v("visibility")])], 1), _vm._v(" "), _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": _vm.isLoading,
            "title": "Edit Driver"
          },
          on: {
            "click": function($event) {
              _vm.openDriverModal(row.item)
            }
          }
        }, [_c('md-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-danger",
            "disabled": _vm.isLoading,
            "title": "Delete Driver"
          },
          on: {
            "click": function($event) {
              _vm.confirmDeleteDriver(row.item)
            }
          }
        }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center my-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  }), _vm._v(" "), _c('strong', [_vm._v("Loading...")])], 1)])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center",
      "limit": "5",
      "disabled": _vm.isLoading
    },
    on: {
      "change": _vm.handlePageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirm Delete",
      "ok-variant": "danger",
      "ok-title": "Delete",
      "cancel-title": "Cancel"
    },
    on: {
      "ok": _vm.deleteDriver,
      "cancel": _vm.cancelDelete
    },
    model: {
      value: (_vm.showDeleteModal),
      callback: function($$v) {
        _vm.showDeleteModal = $$v
      },
      expression: "showDeleteModal"
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("\n      Are you sure you want to delete driver "), _c('strong', [_vm._v(_vm._s(_vm.driverToDelete && _vm.driverToDelete.driverName))]), _vm._v("?\n      This action cannot be undone.\n    ")])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "success",
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        _vm.showSuccessToast = false
      }
    },
    model: {
      value: (_vm.showSuccessToast),
      callback: function($$v) {
        _vm.showSuccessToast = $$v
      },
      expression: "showSuccessToast"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.successMessage) + "\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "Driver-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.isEditMode ? 'Edit Driver' : 'Add Driver'
    },
    on: {
      "hidden": _vm.resetDriverModal
    }
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addDriver($event)
      }
    }
  }, [_c('h6', {
    staticClass: "text-primary mb-3"
  }, [_vm._v("Basic Information")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Location "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "location",
      "name": "location",
      "placeholder": "Enter Location",
      "state": !_vm.errorList.location
    },
    model: {
      value: (_vm.driverModal.location),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "location", $$v)
      },
      expression: "driverModal.location"
    }
  }), _vm._v(" "), (_vm.errorList.location) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.location))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "vehicleNumber",
      "name": "vehicleNumber",
      "placeholder": "Enter Vehicle Number"
    },
    model: {
      value: (_vm.driverModal.vehicleNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "vehicleNumber", $$v)
      },
      expression: "driverModal.vehicleNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Driver Type "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-select', {
    attrs: {
      "size": "sm",
      "id": "driverType",
      "name": "driverType",
      "options": _vm.driverTypeOptions,
      "state": !_vm.errorList.driverType
    },
    model: {
      value: (_vm.driverModal.driverType),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "driverType", $$v)
      },
      expression: "driverModal.driverType"
    }
  }), _vm._v(" "), (_vm.errorList.driverType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.driverType))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("E.Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "eCode",
      "name": "eCode",
      "placeholder": "Enter E.Code"
    },
    model: {
      value: (_vm.driverModal.eCode),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "eCode", $$v)
      },
      expression: "driverModal.eCode"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Name of Driver "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "driverName",
      "name": "driverName",
      "placeholder": "Enter Driver Name",
      "state": !_vm.errorList.driverName
    },
    model: {
      value: (_vm.driverModal.driverName),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "driverName", $$v)
      },
      expression: "driverModal.driverName"
    }
  }), _vm._v(" "), (_vm.errorList.driverName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.driverName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Father's Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "fathersName",
      "name": "fathersName",
      "placeholder": "Enter Father's Name",
      "state": !_vm.errorList.fathersName
    },
    model: {
      value: (_vm.driverModal.fathersName),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "fathersName", $$v)
      },
      expression: "driverModal.fathersName"
    }
  }), _vm._v(" "), (_vm.errorList.fathersName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.fathersName))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('h6', {
    staticClass: "text-primary mb-3 mt-4"
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Mobile Number "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "mobileNumber",
      "name": "mobileNumber",
      "placeholder": "Enter Mobile Number",
      "state": !_vm.errorList.mobileNumber
    },
    on: {
      "blur": function($event) {
        _vm.validateMobile(_vm.driverModal.mobileNumber)
      }
    },
    model: {
      value: (_vm.driverModal.mobileNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "mobileNumber", $$v)
      },
      expression: "driverModal.mobileNumber"
    }
  }), _vm._v(" "), (_vm.errorList.mobileNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.mobileNumber))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Date of Joining")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "date",
      "id": "dateOfJoining",
      "name": "dateOfJoining"
    },
    model: {
      value: (_vm.driverModal.dateOfJoining),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dateOfJoining", $$v)
      },
      expression: "driverModal.dateOfJoining"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Date of Leaving")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "date",
      "id": "dateOfLeaving",
      "name": "dateOfLeaving"
    },
    model: {
      value: (_vm.driverModal.dateOfLeaving),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dateOfLeaving", $$v)
      },
      expression: "driverModal.dateOfLeaving"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "date",
      "id": "dateOfBirth",
      "name": "dateOfBirth"
    },
    model: {
      value: (_vm.driverModal.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dateOfBirth", $$v)
      },
      expression: "driverModal.dateOfBirth"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Aadhar Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "aadharNo",
      "name": "aadharNo",
      "placeholder": "XXXX-XXXX-XXXX"
    },
    on: {
      "blur": function($event) {
        _vm.validateAadhar(_vm.driverModal.aadharNo)
      }
    },
    model: {
      value: (_vm.driverModal.aadharNo),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "aadharNo", $$v)
      },
      expression: "driverModal.aadharNo"
    }
  }), _vm._v(" "), (_vm.errorList.aadharNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.aadharNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("UAN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "uanNumber",
      "name": "uanNumber",
      "placeholder": "Enter UAN Number"
    },
    model: {
      value: (_vm.driverModal.uanNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "uanNumber", $$v)
      },
      expression: "driverModal.uanNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("E.S.I. Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "esiNo",
      "name": "esiNo",
      "placeholder": "Enter ESI Number"
    },
    model: {
      value: (_vm.driverModal.esiNo),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "esiNo", $$v)
      },
      expression: "driverModal.esiNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("DL Number "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "id": "dlNumber",
      "name": "dlNumber",
      "placeholder": "Enter DL Number",
      "state": !_vm.errorList.dlNumber
    },
    on: {
      "blur": function($event) {
        _vm.validateDL(_vm.driverModal.dlNumber)
      }
    },
    model: {
      value: (_vm.driverModal.dlNumber),
      callback: function($$v) {
        _vm.$set(_vm.driverModal, "dlNumber", $$v)
      },
      expression: "driverModal.dlNumber"
    }
  }), _vm._v(" "), (_vm.errorList.dlNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.dlNumber))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isSubmitting,
      "size": "sm"
    }
  }, [(_vm.isSubmitting) ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.isSubmitting ? 'Saving...' : (_vm.isEditMode ? 'Update Driver' : 'Save Driver')) + "\n          ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.hideDriverModal
    }
  }, [_vm._v("\n            Cancel\n          ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        _vm.showErrorToast = false
      }
    },
    model: {
      value: (_vm.showErrorToast),
      callback: function($$v) {
        _vm.showErrorToast = $$v
      },
      expression: "showErrorToast"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a9b1d3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/driverMaster/viewDriverDetail.vue
// module id = 2447
// module chunks = 0